import Chart from "common/components/Chart/Chart";
import { useBubbleChart } from "hooks/chart/UseBubbleChart";
import { head } from "lodash";
import React, { useEffect } from "react";
import { MOREGRAPH } from "utils/constants";

export const BubbleChart = ({ data, xAxis, yAxis }) => {
    const {
        options: optionsLineChart,
        setOptions: setOptionsLineChart,
        showLoading,
        hideLoading,
    } = useBubbleChart();

    useEffect(() => {
        if (Object.keys(data).length > 0) {
            showLoading(); // 🔹 Mostrar loading

            setTimeout(() => {
                let headmapList = [];
                data.group_by_categories.forEach((gCategorie, vIndex) => {
                    data.value_categories.forEach((vCategorie, xIndex) => {
                        const items = data.data
                            .filter(
                                (obj) =>
                                    obj[`group_by_${xAxis}_${yAxis}`][xAxis] === vCategorie &&
                                    obj[`group_by_${xAxis}_${yAxis}`][yAxis] === gCategorie
                            )
                            .map((obj) => [xIndex, vIndex, obj.count]);
                        headmapList = [...headmapList, ...items];
                    });
                });
                setOptionsLineChart({
                    ...optionsLineChart,
                    xAxis: {
                        ...optionsLineChart.xAxis,
                        categories: data.value_categories,
                        type: "category",
                    },
                    yAxis: {
                        ...optionsLineChart.yAxis,
                        categories: data.group_by_categories,
                        type: "category",
                    },
                    series: [
                        {
                            data: headmapList,
                        },
                    ],
                });
                hideLoading();
            }, 100); // Simula un pequeño delay si querés
        } else {
            setOptionsLineChart({
                ...optionsLineChart,
                series: [
                    {
                        ...optionsLineChart.series[0],
                        data: [],
                    },
                ],
            });
        }
    }, [data]);

    return (
        <Chart
            options={optionsLineChart}
            type={MOREGRAPH}
            onChartReady={(chart) => {
                showLoading.chartRef = chart;
            }}
        />
    );
};

export default BubbleChart;
